import { FormGroup, FormControl, Validators } from '@angular/forms';
import { firestore } from 'firebase';
import { InitialContactDialogData } from './initial-contact-dialog/initial-contact-dialog.model';

export class ContactMessageForm {
  public formGroup: FormGroup;
  public serviceDocumentKey: string;
  public userKey: string;
  public backupId: any;

  constructor(serviceKey: string, userKey: string) {
    this.serviceDocumentKey = serviceKey;
    this.userKey = userKey;
    this.initializeForm();
  }

  get model(): InitialContactDialogData {
    const model = new InitialContactDialogData({
      clientUserKey: this.userKey,
      serviceDocumentKey: this.serviceDocumentKey,
      message: this.formGroup.value?.message,
      timeStamp: firestore.Timestamp.now()
    });

    return model;
  }

  public resetMessage() {
    this.formGroup.reset();
  }

  get validators() {
    return {
      message: [
        {
          type: 'required',
          message: 'Message is required.'
        }
      ]
    };
  }
  private initializeForm() {
    this.formGroup = new FormGroup({
      message: new FormControl('', [Validators.required])
    });
  }
}
